"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GraphNodeType = void 0;
var GraphNodeType;
(function (GraphNodeType) {
    GraphNodeType["INTERNAL"] = "INTERNAL";
    GraphNodeType["EXTERNAL"] = "EXTERNAL";
})(GraphNodeType = exports.GraphNodeType || (exports.GraphNodeType = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ3JhcGguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvZ3JhcGgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBR0EsSUFBWSxhQUdYO0FBSEQsV0FBWSxhQUFhO0lBQ3ZCLHNDQUFxQixDQUFBO0lBQ3JCLHNDQUFxQixDQUFBO0FBQ3ZCLENBQUMsRUFIVyxhQUFhLEdBQWIscUJBQWEsS0FBYixxQkFBYSxRQUd4QiJ9